var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ffffff",
    stroke: "null",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 19.72547,
    cy: 19.22992,
    id: "svg_2",
    rx: 18.42828,
    ry: 18.42828
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.95196,0c-11.01747,0 -19.95196,8.76888 -19.95196,19.58285c0,10.98355 8.72898,18.49147 19.95196,28.30185c11.22298,-9.81038 19.95196,-17.3183 19.95196,-28.30185c0,-10.81396 -8.93449,-19.58285 -19.95196,-19.58285zm0,35.91352c-8.81677,0 -15.96157,-7.14679 -15.96157,-15.96157s7.1448,-15.96157 15.96157,-15.96157s15.96157,7.14679 15.96157,15.96157s-7.1448,15.96157 -15.96157,15.96157z",
    id: "svg_1",
    stroke: "white",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.9aeb9e402f8fee4b750ec34c7a910e9d.svg";
export { ForwardRef as ReactComponent };